let ROOT_URL

if (process.env.VERCEL_URL) {
  ROOT_URL = `https://${process.env.VERCEL_URL}`
}

module.exports = {
  ROOT_URL: ROOT_URL || process.env.DEPLOY_URL || process.env.DEPLOY_URL_PLACEHOLDER,
}
